/* ===========================================================
   Hide the Shopify chat bubble when it would overlap checkout UI:
   - Sticky add-to-cart bar (.sticky-cart.is-visible)
   - Cart drawer (body.header-mini-cart-open)
   - Cart page on mobile (body.template-cart, <=749px)
   Covers both the legacy Shopify Inbox (#ShopifyChat) and the
   current <shopify-chat> custom element. Restores chat otherwise.
   =========================================================== */
(function () {
  var STYLE_ID = 'sticky-cart-inbox-fix-style';
  var BODY_CLASS = 'inbox-chat-suppressed';
  var CHAT_SEL = '#ShopifyChat, #ShopifyChatContainer, [id^="ShopifyChat"], shopify-chat, [id^="shopify-chat" i], iframe[name*="chat" i]';

  function ensureStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent =
      'body.' + BODY_CLASS + ' #ShopifyChat,' +
      'body.' + BODY_CLASS + ' #ShopifyChatContainer,' +
      'body.' + BODY_CLASS + ' [id^="ShopifyChat"],' +
      'body.' + BODY_CLASS + ' shopify-chat,' +
      'body.' + BODY_CLASS + ' [id^="shopify-chat" i],' +
      'body.' + BODY_CLASS + ' iframe[name*="chat" i] {' +
      '  visibility: hidden !important;' +
      '  pointer-events: none !important;' +
      '  opacity: 0 !important;' +
      '  transition: opacity 0.2s ease-in-out;' +
      '}';
    document.head.appendChild(s);
  }

  function patchInline(hide) {
    var nodes = document.querySelectorAll(CHAT_SEL);
    nodes.forEach(function (el) {
      if (hide) {
        el.style.visibility = 'hidden';
        el.style.pointerEvents = 'none';
        el.style.opacity = '0';
      } else {
        el.style.visibility = '';
        el.style.pointerEvents = '';
        el.style.opacity = '';
      }
    });
  }

  function shouldSuppress() {
    var stickyVisible = !!document.querySelector('.sticky-cart.is-visible');
    var drawerOpen = document.body.classList.contains('header-mini-cart-open');
    var isMobile = window.matchMedia('(max-width: 749px)').matches;
    var onCartPage = isMobile && document.body.classList.contains('template-cart');
    return stickyVisible || drawerOpen || onCartPage;
  }

  function update() {
    var suppress = shouldSuppress();
    document.body.classList.toggle(BODY_CLASS, suppress);
    patchInline(suppress);
  }

  function init() {
    ensureStyle();
    update();

    var stickyCart = document.querySelector('.sticky-cart');
    if (stickyCart) {
      new MutationObserver(update).observe(stickyCart, { attributes: true, attributeFilter: ['class'] });
    } else {
      setTimeout(function () {
        var sc = document.querySelector('.sticky-cart');
        if (sc) new MutationObserver(update).observe(sc, { attributes: true, attributeFilter: ['class'] });
      }, 1000);
    }

    // body class (drawer open) + window resize (mobile cart page)
    new MutationObserver(update).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('resize', update);

    // chat loads async; reapply when the chat element appears
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        for (var j = 0; j < mutations[i].addedNodes.length; j++) {
          var n = mutations[i].addedNodes[j];
          if (n.nodeType !== 1) continue;
          // n.id is not always a string: a <form> containing <input name="id">
          // (every Shopify product form) exposes that input as form.id.
          var nid = (typeof n.id === 'string') ? n.id.toLowerCase() : '';
          if (n.tagName === 'SHOPIFY-CHAT' ||
              nid.indexOf('shopifychat') === 0 ||
              nid.indexOf('shopify-chat') === 0) {
            update();
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
